import React from "react";

const DeleteAccount = () => {
  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1 style={styles.heading}>Delete Your Account</h1>

        <p style={styles.text}>
          If you want to delete your Freshcart account and all associated data,
          please follow the instructions below.
        </p>

        <h3 style={styles.subheading}>How to request account deletion:</h3>
        <p style={styles.text}>
          Send an email to:{" "}
          <span style={styles.email}>
            vishalthakurktrr44@gmail.com
          </span>
        </p>

        <p style={styles.text}>
          Include your registered phone number and request account deletion.
        </p>

        <h3 style={styles.subheading}>What happens next?</h3>
        <p style={styles.text}>
          - Your account will be permanently deleted within 2–5 business days.
          <br />
          - All your personal data will be removed from our system.
          <br />
          - This action cannot be undone.
        </p>

        <a
          href="mailto:vishalthakurktr44@gmail.com"
          style={styles.button}
        >
          Request Account Deletion
        </a>
      </div>
    </div>
  );
};

const styles = {
  body: {
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    padding: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    maxWidth: "600px",
    background: "#fff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
  },
  heading: {
    color: "#2c3e50",
  },
  subheading: {
    marginTop: "20px",
  },
  text: {
    lineHeight: "1.6",
    color: "#555",
  },
  email: {
    fontWeight: "bold",
    color: "#007bff",
  },
  button: {
    display: "inline-block",
    marginTop: "20px",
    padding: "10px 20px",
    background: "#ff4d4d",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "5px",
  },
};

export default DeleteAccount;